export default __webpack_public_path__ + "static/media/icon-online.77064fbb.svg";